export default {"src":"/_next/static/media/snapchat.a12102ad.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};